import React, { useState } from 'react';

interface Box {
  id: string;
  title: string;
  content: React.ReactNode;
  color?: string;
}

interface JigSawModuleProps {
  backgroundImage?: string;
  backgroundColor?: string;
  boxes: Box[];
}

export const JigSawModule2: React.FC<JigSawModuleProps> = ({
  backgroundImage,
  backgroundColor,
  boxes,
}) => {
  const [selectedBox, setSelectedBox] = useState<Box | null>(null);

  return (
    <div className="flex items-center bg-gray-100 justify-center mt-8">
      <div
        className={`max-w-full min-h-[440px] rounded-3xl relative flex justify-center items-center `}
        style={{
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
          backgroundColor: backgroundImage ? 'transparent' : backgroundColor || '#ddd',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className={`${!selectedBox ? 'grid grid-cols-4 gap-10 w-auto h-48 z-10' : 'hidden'}`}>
          {boxes.map((box) => (
            <button
              key={box.id}
              onClick={() => setSelectedBox(box)}
              className="w-20 h-20 transform rotate-45 flex items-center justify-center text-black font-bold text-sm p-2 rounded-lg transition-all duration-300 shadow-md"
              style={{ backgroundColor: box.color || '#FFFFFF' }}
            >
              <span className="transform -rotate-45">{box.title}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Right Side */}
      {selectedBox && (
        <div className="w-full min-h-[400px] max-h-[514px] p-2  shadow-lg relative rounded-3xl ">
          {/* Close button at top-left */}
          <button
            className="absolute top-2 right-2 bg-gray-200 hover:bg-gray-300 text-black px-2 py-1 rounded-full font-bold"
            onClick={() => setSelectedBox(null)}
          >
            X
          </button>

          {selectedBox.title && (
            <h2
              className="text-xl font-bold text-black px-1 py-1 rounded mt-2 ml-2"
              style={{ backgroundColor: selectedBox.color }}
            >
              {selectedBox.title}
            </h2>
          )}
          {selectedBox.content && (
            <div className="mt-2 ml-2 leading-6 text-gray-800">{selectedBox.content}</div>
          )}
        </div>
      )}
    </div>
  );
};
